import { Colors } from "@brg/ui"

export const hintToolbarStylesWhite = {
  fontFamily: 'Inter',
  fontWeight: 400,
  padding: '2px 8px 4px 8px', 
  fontSize: '11px', 
  lineHeight: '13px', 
  letterSpacing: '-0.02em',
  color: Colors.galBlack61,
  backgroundColor: Colors.galBlack10,
  background: Colors.galBlack10
}

export const hintToolbarStylesDark= {
  fontFamily: 'Inter',
  fontWeight: 400,
  padding: '2px 8px 4px 8px', 
  fontSize: '11px', 
  lineHeight: '13px', 
  letterSpacing: '-0.02em',
  color: '#fff',
  backgroundColor: '#353A3E',
  background: '#353A3E'
}import { Colors } from "@brg/ui"

export const hintToolbarStylesWhite = {
  fontFamily: 'Inter',
  fontWeight: 400,
  padding: '2px 8px 4px 8px', 
  fontSize: '11px', 
  lineHeight: '13px', 
  letterSpacing: '-0.02em',
  color: Colors.galBlack61,
  backgroundColor: Colors.galBlack10,
  background: Colors.galBlack10
}

export const hintToolbarStylesDark= {
  fontFamily: 'Inter',
  fontWeight: 400,
  padding: '2px 8px 4px 8px', 
  fontSize: '11px', 
  lineHeight: '13px', 
  letterSpacing: '-0.02em',
  color: '#fff',
  backgroundColor: '#353A3E',
  background: '#353A3E'
}